import 'es6-promise/auto'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import rest from './utils/rest'
import BootstrapVue from 'bootstrap-vue';
import da from 'vee-validate/dist/locale/da';
import VeeValidate, {Validator} from 'vee-validate';
import VModal from 'vue-js-modal'
import './lang.js'

// Config
Vue.config.productionTip = false
Vue.config.debug = true

// Form validation langugage
Validator.localize('da', da);
Validator.extend('password_repeat', {
    getMessage: field => 'De to adgangskoder skal være ens',
    validate: (value, targetValue) => {
        return value === targetValue.toString()
    }
});

// Add dependencies
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);
Vue.use(BootstrapVue);
Vue.use(VModal, {
    dialog: true,
    dynamic: true,
});
Vue.use(VeeValidate, {
    inject: false,
    dictionary: {
        da: {
            attributes: {
                'email': 'E-mail',
                'phone': 'Telefon',
                'name': 'Navn',
                'password': 'Adgangskode',
                'password2': 'Gentaget adgangskode'
            }
        }
    }
});
Vue.use(rest);

// Add snippets
import loader from "./components/layout/snippets/loader.vue"
import panel from "./components/layout/snippets/panel.vue"

Vue.component('loader', loader)
Vue.component('panel', panel)

new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js